import React from "react";
import InputField from "../../../Components/InputField";
import { Box, Card, Typography } from "@mui/material";
import CustomTypography from "../../../Components/Typography";
import muiStyles from "../styles/muiStyles";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import SingleSelectAutocomplete from "../../../Components/SingleSelectAutocomplete";

const BankAccount = ({
  isloading,
  banks,
  branches,
  selectedBank,
  selectedBranch,
  handleBankChange,
  handleBranchChange,
  bankErrors,
  setBankErrors,
}) => {
  const { t } = useTranslation("page-business-settings");
  const {
    cardStyles,
    inputGridStyles,
    bankHeadingWrapper,
    bankHeadingTextBox,
    fieldsLabelStyles,
    fieldsLabelLightStyles,
  } = muiStyles;

  const { handleChange, values } = useFormikContext();

  const handleAccountNumberBlur = (value) => {
    if (value?.trim()) {
      setBankErrors((prev) => ({ ...prev, accountNumber: "" }));
    }
  };

  const handleBankBlur = (value) => {
    if (value) {
      setBankErrors((prev) => ({ ...prev, bankId: "" }));
    }
  };

  const handleBranchBlur = (value) => {
    if (value) {
      setBankErrors((prev) => ({ ...prev, branchId: "" }));
    }
  };

  return (
    <Card sx={{ ...cardStyles, overflow: "unset" }}>
      <Box sx={bankHeadingWrapper}>
        <Box sx={bankHeadingTextBox}>
          <CustomTypography type="subheading">
            {t("bank_account_heading")}
          </CustomTypography>

          <Typography color="rgba(47, 43, 61, 0.9)" sx={fieldsLabelLightStyles}>
            {t("bank_account_subtext")}
          </Typography>
        </Box>

        <Box sx={{ width: "24px", height: "24px" }}>
          <img src="/icons/shield-icon.svg" alt="shield-icon" />
        </Box>
      </Box>

      <Box
        sx={{
          ...inputGridStyles,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          pt: "32px",
        }}
      >
        <Box>
          <Typography sx={{ ...fieldsLabelStyles, mb: "8px" }}>
            {t("bank_name")}
          </Typography>
          <SingleSelectAutocomplete
            options={banks.map((bank) => ({
              value: bank.id,
              label: `${bank.id} - ${bank.name}`,
            }))}
            onChange={handleBankChange}
            value={selectedBank}
            placeholder={t("select_bank")}
            onBlur={(e) => handleBankBlur(e.target.value)}
            disabled={isloading}
            error={!!bankErrors.bankId}
            helperText={bankErrors.bankId}
          />
        </Box>

        <Box>
          <Typography sx={{ ...fieldsLabelStyles, mb: "8px" }}>
            {t("branch_number")}
          </Typography>

          <SingleSelectAutocomplete
            options={branches.map((branch) => ({
              value: branch.id,
              label: `${branch.id} - ${branch.name}`,
            }))}
            onChange={handleBranchChange}
            value={selectedBranch}
            placeholder={t("select_branch")}
            onBlur={(e) => handleBranchBlur(e.target.value)}
            disabled={!selectedBank || isloading}
            error={!!bankErrors.branchId}
            helperText={bankErrors.branchId}
          />
        </Box>

        <InputField
          name="bankAccount.accountNumber"
          label={t("account_number")}
          type="number"
          value={values.bankAccount?.accountNumber || ""}
          onChange={handleChange}
          onBlur={(e) => handleAccountNumberBlur(e.target.value)}
          placeholder={t("account_number")}
          disabled={isloading}
          error={!!bankErrors.accountNumber}
          helperText={bankErrors.accountNumber}
        />
      </Box>
    </Card>
  );
};

export default BankAccount;
